import React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import News from './pages/News';
import Cinemas from './pages/Cinemas';
import Trailers from './pages/Trailers';
import Apropos from './pages/APropos';
import AppliMobile from "./pages/AppliMobile";
import FilmDetail from './components/FilmDetail';
import Cookies from './pages/Cookies';
import Confidentialite from './pages/Confidentialite';
import CGU from './pages/CGU';
import MentionsLegales from './pages/MentionLegales';
import Partenariat from './pages/Partenariat';
import Homepage_deep from './pages/HomePage';
import TicketPurchase from './pages/TicketPurchase';
import NewsDetail from './pages/NewsDetail';
import UserInfo from './pages/UserInfo';
import Wishlist from './pages/Wishlist';
import Points from './pages/Points';
import AccountCountdown from './pages/AccountCountdown.js';
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from 'framer-motion';

// Configuration d'animation
const pageVariants = {
  initial: {
    opacity: 0,
    y: 50,
    scale: 0.98
  },
  in: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: "easeInOut"
    }
  },
  out: {
    opacity: 0,
    y: -50,
    scale: 0.98,
    transition: {
      duration: 0.5,
      ease: "easeInOut"
    }
  }
};

function App() {
  const [countdownFinished, setCountdownFinished] = useState(false);
  const targetDate = new Date("2025-02-20T20:50:59");

  // Vérification initiale au chargement
  useEffect(() => {
    setCountdownFinished(true);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <AnimatePresence mode="wait">
          {countdownFinished ? (
            <>
              <motion.div
                key="main-app"
                initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                layout
              >
                <Header />
                <br /><br /><br />
                <Routes>
                  <Route path="/pages/news" element={<News />} />
                  <Route path="/pages/cinemas" element={<Cinemas />} />
                  <Route path="/pages/trailers" element={<Trailers />} />
                  <Route path="/pages/apropos" element={<Apropos />} />
                  <Route path="/pages/applimobile" element={<AppliMobile />} />
                  <Route path="/" element={<Cinemas />} />
                  <Route path="/film/:slug" element={<FilmDetail />} />
                  <Route path="/pages/cookies" element={<Cookies />} />
                  <Route path="/pages/confidentialite" element={<Confidentialite />} />
                  <Route path="/pages/cgu" element={<CGU />} />
                  <Route path="/pages/mentions-legales" element={<MentionsLegales />} />
                  <Route path="/pages/partenariat" element={<Partenariat />} />
                  <Route path="/pages/ticket/:id" element={<TicketPurchase />} />
                  <Route path="/news/:id" element={<NewsDetail />} />
                  <Route path="/pages/profile" element={<UserInfo />} />
                  <Route path="/pages/wishlist" element={<Wishlist />} />
                  <Route path="/pages/points" element={<Points />} />
                </Routes>
                <Footer />
              </motion.div>
            </>
          ) : (
            <motion.div
              key="countdown"
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              style={{ position: 'fixed', width: '100%', height: '100%' }}
            >
              {/* <Routes>
                <Route
                  path="/"
                  element={<AccountCountdown onCountdownFinish={() => setCountdownFinished(true)} />}
                />
              </Routes> */}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </Router>
  );
}

export default App;
